import React, {useEffect, useState} from "react";
import {T} from "@tolgee/react";
import {Box, Button, Typography} from "@material-ui/core";
import FlexBox from "view/components/Layout/FlexBox";
import {useParams} from "react-router-dom";
import {useFormStateContext} from "view/SignUp/SignUpToken/context";
import {apiV2} from "api/firebase";
import {getRetryAfterSeconds} from "tools/error";
import useStyles from "./styles";

const RESEND_COUNTDOWN = 120;
const ONE_SECOND = 1000;

const ResendButton = () => {
  const classes = useStyles();
  const [canResend, setCanResend] = useState<boolean>(true);
  const [countdown, setCountdown] = useState<number | null>(null);
  const {signUpResult, show} = useFormStateContext();
  const {uid: token} = useParams();
  const sendInvite = () => {
    if (!signUpResult || !show || !token) {
      return;
    }
    apiV2.embeddedShows
      .resendExhibitorInvite({
        connectionUserId: signUpResult.connectionUserId,
        showId: show.id,
        token,
      })
      .catch((e) => {
        // Rate limited: keep the button off for as long as the API asks,
        // not just the local countdown.
        const retryAfter = getRetryAfterSeconds(e);
        if (retryAfter) {
          setCanResend(false);
          setCountdown((current) => Math.max(current ?? 0, retryAfter));
        }
        console.error("Error occurred sending exhibitor invite link", e);
      });
  };
  const onClick = () => {
    setCanResend(false);
    setCountdown(RESEND_COUNTDOWN);
    sendInvite();
  };
  useEffect(() => {
    if (countdown === null) {
      return;
    }
    let timeout: NodeJS.Timeout;
    if (countdown > 0) {
      timeout = setTimeout(() => {
        setCountdown(() => countdown - 1);
      }, ONE_SECOND);
      return;
    }
    setCanResend(true);
    setCountdown(null);
    return () => clearTimeout(timeout);
  }, [countdown]);
  return (
    <FlexBox column gap={1} className={classes.sendAgainWrapper}>
      <Box className={classes.sendAgainSection}>
        <Typography className={classes.sendAgainText}>
          <T keyName="global.sign_up.resend.didnt_receive" />
        </Typography>
        <Button
          variant="text"
          color="primary"
          className={classes.buttonText}
          disabled={!canResend}
          onClick={onClick}
        >
          <T keyName="global.sign_up.resend.send_again" />
        </Button>
      </Box>
      {countdown !== null && (
        <Typography variant="body2">
          <T
            keyName="global.sign_up.resend.try_again"
            params={{
              time: `${Math.floor(countdown / 60)}:${String(
                countdown % 60
              ).padStart(2, "0")}`,
            }}
          />
        </Typography>
      )}
    </FlexBox>
  );
};

export default ResendButton;
